import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'product/:id',
    loadComponent: () => import('./pages/public-product-detail/public-product-detail.component').then(m => m.PublicProductDetailComponent),
    data: { public: true },
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [authGuard],
  },
  // {
  //   path: 'bulk-upload',
  //   loadComponent: () => import('./pages/bulk-upload/bulk-upload.component').then(m => m.BulkUploadComponent),
  //   canActivate: [authGuard],
  // },
  {
    path: 'batch-creation',
    loadComponent: () => import('./pages/batch-creation/batch-creation.component').then(m => m.BatchCreationComponent),
    canActivate: [authGuard],
  },
  {
    path: 'qr-status',
    loadComponent: () => import('./pages/qr-code-status/qr-code-status.component').then(m => m.QrCodeStatusComponent),
    canActivate: [authGuard],
  },
  {
    path: 'records',
    loadComponent: () => import('./pages/records/records.component').then(m => m.RecordsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'reports',
    loadComponent: () => import('./pages/reports/reports.component').then(m => m.ReportsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'batch/:id/records',
    loadComponent: () => import('./pages/batch-details/batch-details.component').then(m => m.BatchDetailsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'users',
    loadComponent: () => import('./pages/users/users.component').then(m => m.UsersComponent),
    canActivate: [authGuard],
  },
  {
    path: 'error-demo',
    loadComponent: () => import('./components/error-demo/error-demo.component').then(m => m.ErrorDemoComponent),
    canActivate: [authGuard],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
